import { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router'

import { useNotifications } from 'app/application/application'
import { PublicRoutes } from 'app/application/types'
import { InboxIcon } from 'app/common/presentation/icons'
import { useUser } from 'app/user/application'

import { Headline } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import styles from './CheckInbox.module.scss'

interface CheckInboxInfos {
  email: string
}

const CheckInbox = () => {
  const location = useLocation()
  const { createNotification } = useNotifications()
  const { t } = useTranslation('user')

  const { triggerPasswordReset } = useUser()

  const state = location.state as CheckInboxInfos | null
  const { email } = state ?? {}

  if (!email) {
    return <Navigate to={PublicRoutes.ResetPassword} replace />
  }

  const handlePasswordRest = (e: SyntheticEvent) => {
    e.preventDefault()

    void triggerPasswordReset(email).then((result) => {
      if (result.ok) {
        createNotification({ message: t('resetPassword.checkInbox.description'), type: 'success' })
      } else {
        createNotification({ message: result.val.message, type: 'error' })
      }
    })
  }

  return (
    <div className={accessStyles.access}>
      <div className={styles.checkInbox}>
        <div>
          <InboxIcon />
          <Headline>{t('resetPassword.checkInbox.title')}</Headline>
          <div className={styles.description}>
            {t('resetPassword.checkInbox.description', { email })}
          </div>
        </div>
        <div className={styles.noEmail}>
          {t('resetPassword.checkInbox.noEmail')}{' '}
          <a href="" onClick={handlePasswordRest}>
            {t('resetPassword.checkInbox.resendLink')}
          </a>
        </div>
      </div>
    </div>
  )
}

export default CheckInbox
